/**
 * THE TWO iOS GLYPHS AN INSTALL WALKTHROUGH NEEDS, hand-drawn.
 *
 * Apple gives a web page no install prompt to trigger, and `navigator.share()`
 * opens the CONTENT-sharing sheet — Messages, Mail, Copy — which does not
 * contain „Adaugă pe ecranul principal" at all: that entry lives only in the
 * browser's own toolbar share menu, which no page can open. So the only
 * honest install UI is instructions, and instructions about buttons work by
 * SHOWING the button: "the square with the arrow" is findable on a toolbar,
 * a sentence about a "share button" is not.
 *
 * Drawn in the house stroke vocabulary (see PaymentMark in Checkout.tsx),
 * never imported from an icon set. Both take the text colour of their row.
 */

/** The iOS share mark: the open box, the arrow leaving it upward. */
export function ShareMark() {
  return (
    <svg
      width="20" height="20" viewBox="0 0 24 24" fill="none"
      aria-hidden="true" focusable="false" className="shrink-0"
    >
      <path d="M8 9H5.5v11.5h13V9H16" stroke="currentColor" strokeWidth="2" />
      <path d="M12 14.5V3.5M8.5 7L12 3.5 15.5 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** The iOS "add to Home Screen" mark: the square with the plus in it. */
export function AddHomeMark() {
  return (
    <svg
      width="20" height="20" viewBox="0 0 24 24" fill="none"
      aria-hidden="true" focusable="false" className="shrink-0"
    >
      <rect x="4.5" y="4.5" width="15" height="15" stroke="currentColor" strokeWidth="2" />
      <path d="M12 8.5v7M8.5 12h7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
